export default {"src":"/_next/static/media/LongHorn.3d61cbe6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};